import React, { useState } from 'react';

/* MobX */
import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Tabs, Tab, Paper } from '@material-ui/core';

/* Langan Components */
// import SearchAddress from './address/SearchAddress';
import ManageAlternateAddresses from '../address/ManageAlternateAddress';
import ManageRetiredAddresses from '../address/ManageRetiredAddress';
import ManageUndeterminedAddress from '../address/ManageUndeterminedAddress';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  wrapper: {
    textTransform: 'initial'
  }
}));

const ManageAddresses = observer(props => {
  const classes = useStyles();

  // To handle tabs:
  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  }

  return (
    <Container maxWidth="md">
      <Paper className={classes.paper}>
        <Tabs value={selectedTab} onChange={handleTabChange}>
          {/* <Tab label="Search Address" /> */}
          <Tab label="Alternate Address" className={classes.wrapper}/>
          {/* <Tab label="Retired Address" className={classes.wrapper}/>
          <Tab label="Undetermined Address" className={classes.wrapper}/> */}
        </Tabs>
        {/* {selectedTab === 0 &&
        <SearchAddress />
      } */}
        {selectedTab === 0 &&
          <ManageAlternateAddresses />
        }
        {/* {selectedTab === 1 &&
          <ManageRetiredAddresses />
        }
        {selectedTab === 2 &&
          <ManageUndeterminedAddress />
        } */}
      </Paper>
    </Container>
  )
});

export default ManageAddresses;
